export enum DataHooks {
  ROOT = 'more-info-button-root',
}
